import React from 'react';
import SharedNavbarTop from 'shared_items/NavbarTop';

// Wrapper de compatibilidade — preserva a assinatura original (activeTab, toggle settings/voltar).
// Implementação real em shared_items/NavbarTop.jsx (design-system fase 2). Remover em fase 3.
const NavbarTop = ({ title = 'Planner', onHomeClick, onLogoutClick, handleTabChange, activeTab }) => (
  <SharedNavbarTop
    title={title}
    moduleKey="planner"
    onHomeClick={onHomeClick}
    zIndexClass="z-20"
    settingsActive={activeTab === 'settings'}
    onSettingsClick={() => handleTabChange && handleTabChange(activeTab === 'settings' ? 'todo' : 'settings')}
  />
);

export default NavbarTop;
